import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import CreateWarehousePurchaseContainer from 'app/containers/InventoryManagement/WarehousePurchase/pages/create'

const CreateWarehousePurchaseContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <CreateWarehousePurchaseContainer />
    </>
  )
}
const CreateWarehousePurchaseContainerPage = memo(CreateWarehousePurchaseContainerPageCpn, isEqual)

export default CreateWarehousePurchaseContainerPage
